module.exports = __webpack_public_path__ + "6afe4aa5fb833b1bc90115e302dcd835.png";